import { chartColours } from "../../themes/colours";
import { gis2QueryUrl } from "../../utils/urls.js"

const opportunityAreaAdoptedLayer = {
    layer: {
      id: "opportunity-area-adopted",
      type: "fill",
      paint: {
        "fill-color": chartColours.ldnDkPink,
        "fill-opacity": 0.7,
        "fill-outline-color": "#000000",
      },
      layout: {
        visibility: "none",
      },
    },
    source: {
      id: "opportunity-area-adopted",
      type: "geojson",
      data: gis2QueryUrl("opportunity_areas_webmap", 20),
    },
    labels: {
      parent: "Adopted",
    },
    filters: {
      filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: "planning",
    grouping: "opportunity",
    popupAttributes: ["sitename", "status"],
  }

const opportunityAreaEmergingLayer = {
    layer: {
      id: "opportunity-area-emerging",
      type: "fill",
      paint: {
        "fill-color": chartColours.ldnDkPink,
        "fill-opacity": 0.7,
        "fill-outline-color": "#000000",
      },
      layout: {
        visibility: "none",
      },
    },
    source: {
      id: "opportunity-area-emerging",
      type: "geojson",
      data: gis2QueryUrl("opportunity_areas_webmap", 21),
    },
    labels: {
      parent: "Emerging",
    },
    filters: {
      filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: "planning",
    grouping: "opportunity",
    popupAttributes: ["sitename", "status"],
  }

const opportunityAreaDefinedLayer = {
    layer: {
      id: "opportunity-area-defined",
      type: "fill",
      paint: {
        "fill-color": chartColours.ldnDkPink,
        "fill-opacity": 0.7,
        "fill-outline-color": "#000000",
      },
      layout: {
        visibility: "none",
      },
    },
    source: {
      id: "opportunity-area-defined",
      type: "geojson",
      data: gis2QueryUrl("opportunity_areas_webmap", 22),
    },
    labels: {
      parent: "Defined",
    },
    filters: {
      filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: "planning",
    grouping: "opportunity",
    popupAttributes: ["sitename", "status"],
  }

export const planningLayerDefsOpportunity = {
  "opportunity-area-adopted": opportunityAreaAdoptedLayer,
  "opportunity-area-emerging": opportunityAreaEmergingLayer,
  "opportunity-area-defined": opportunityAreaDefinedLayer,
}
